/* Clients Store */

import {
  fetchClient,
  fetchAverageDaysBetweenOrders,
  fetchHistoricalMargins
} from '@/api'
import {fetchClientAddresses} from "../../api";

const getInitialState = () => {
  return {
    client: {
      custno: '',
      company: '',
      address1: '',
      address2: '',
      city: '',
      state: '',
      zip: '',
      country: '',
      phone: '',
      fax: '',
      email: '',
      url: '',
      onOrder: '',
      balance: '',
      pTerms: '',
      vic: '',
      transBuyer: '',
      sic: '',
      sic2: '',
      sic3: '',
      naics: '',
      naics2: '',
      naics3: '',
      omr: '',
      indType: '',
      source: '',
      enteredOn: '',
      terr: '',
      salesmn: '',
      arVic: '',
      tax: '',
      code: '',
      nlacno: '',
      industryTypeId: '',
      notes: ''
    },
    daysBetweenOrders: 0,
    projectedNextOrderDate: '',
    historicalMargins: [],
    salesOrderAddress: {}
  }
}

let state = getInitialState()

const actions = {
  fetchClient (context, clientCode) {
    return fetchClient(clientCode).then((response) => {
      context.commit('setClient', response.data)
    })
  },
  fetchAverageDaysBetweenOrders (context, clientCode) {
    return fetchAverageDaysBetweenOrders(clientCode).then((response) => {
      context.commit('setAverageDaysBetweenOrders', response.data)
    })
  },
  fetchHistoricalMargins (context, clientCode) {
    return fetchHistoricalMargins(clientCode).then((response) => {
      context.commit('setHistoricalMargins', response.data)
    })
  },
  fetchClientAddressByCshipno (context, params) {
    return fetchClientAddresses ({custno: params.custno, cshipno: params.cshipno}).then(r => {
      context.commit('setSOAddress', r.data)
    })
  },
  resetClient (context) {
    context.commit('resetClient')
  }
}

const mutations = {
  setClient (state, payload) {
    state.client = payload
  },
  setAverageDaysBetweenOrders (state, payload) {
    state.daysBetweenOrders = payload.averageDaysBetweenOrders
    state.projectedNextOrderDate = payload.projectedNextOrderDate
  },
  setHistoricalMargins (state, payload) {
    state.historicalMargins = payload
  },
  setSOAddress (state, payload) {
    if (payload.length !== 1) {
      return
    }
    state.salesOrderAddress = payload[0]
  },
  resetClient (state) {
    Object.assign(state, getInitialState())
  }
}

const getters = {
  getClient () {
    return state.client
  },
  getSalesOrderAddress (state) {
    return state.salesOrderAddress
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
